import { Button, Chip, Stack } from '@mui/material';
import { FiberManualRecord as DotIcon } from '@mui/icons-material';
import { APP_CONFIG } from '../../../../config/app.config';

const colors = APP_CONFIG.ui.theme.colors;

interface ConnectionAuthStatusProps {
    authorized: boolean;
    /** Defaults to true when omitted (connectors without a setup step). */
    active?: boolean;
    isReconnecting?: boolean;
    onReconnect: () => void;
}

/** Status badge for a connection: connected, inactive (setup unfinished), or reconnect required. */
export const ConnectionAuthStatus = ({
    authorized,
    active = true,
    isReconnecting,
    onReconnect,
}: ConnectionAuthStatusProps) => {
    const status = !authorized
        ? { label: 'Reconnect required', color: colors.error }
        : !active
            ? { label: 'Inactive', color: colors.warning }
            : { label: 'Connected', color: colors.success };

    return (
        <Stack direction="row" alignItems="center" spacing={1.5}>
            <Chip
                size="small"
                variant="outlined"
                icon={<DotIcon sx={{ fontSize: 10 }} />}
                label={status.label}
                sx={{
                    color: status.color,
                    borderColor: status.color,
                    backgroundColor: `${status.color}14`,
                    fontWeight: 600,
                    '& .MuiChip-icon': { color: status.color },
                }}
            />

            {!authorized && (
                <Button
                    variant="contained"
                    color="error"
                    size="small"
                    disabled={isReconnecting}
                    onClick={(e) => {
                        e.stopPropagation();
                        onReconnect();
                    }}
                >
                    Reconnect
                </Button>
            )}
        </Stack>
    );
};
